import { Api } from './axios-config';
import { IBusinessEmployeeView, ICreateBusinessEmployee, IUpdateBusinessEmployee } from './employeeService';

const getById = async (id: number): Promise<IBusinessEmployeeView> => {
  try {
    const { data } = await Api.get<IBusinessEmployeeView>(
      `/businessEmployee/${id}?includeAppointments=false`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByUserIdAndBusinessId = async (
  userId: number,
  businessId: number
): Promise<IBusinessEmployeeView> => {
  try {
    const { data } = await Api.get(
      `/businessEmployee/user/${userId}/business/${businessId}`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const get = async (businessId?: number, activeOnly?: boolean): Promise<IBusinessEmployeeView[]> => {
  try {
    const params = new URLSearchParams();
    if (businessId) params.append('businessId', businessId.toString());
    if (activeOnly !== undefined) params.append('activeOnly', String(activeOnly));
    const query = params.toString();
    const { data } = await Api.get(`/businessEmployee${query ? `?${query}` : ''}`);

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const create = async (body: ICreateBusinessEmployee): Promise<number> => {
  try {
    const { data } = await Api.post(
      '/businessEmployee',
      body
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const update = async (body: IUpdateBusinessEmployee): Promise<IBusinessEmployeeView> => {
  try {
    const { data } = await Api.put(
      '/businessEmployee',
      body
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const remove = async (id: number): Promise<void> => {
  try {
    await Api.delete(
      `/businessEmployee/${id}`
    );

  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getAvailableSpots = async (
  id: number,
  day: number,
  month: number,
  serviceDuration: number,
  includeOccupied?: boolean
): Promise<string[]> => {
  try {
    const queryParams: Record<string, string> = {
      id: id?.toString(),
      day: day?.toString(),
      month: month?.toString(),
      serviceDuration: serviceDuration?.toString(),
    };
    if (includeOccupied) {
      queryParams.includeOccupied = 'true';
    }

    const { data } = await Api.get('/businessEmployee/availableSpots', {
      params: queryParams,
    });

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const uploadFile = async (id: number, file: FormData): Promise<string> => {
  try {
    const { data } = await Api.post<string>(
      `/businessEmployee/${id}/upload`, file
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const deleteFile = async (id: number): Promise<string> => {
  try {
    const { data } = await Api.delete<string>(
      `/businessEmployee/${id}/profile-picture`
    );

    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const businessEmployeeService = {
  getById,
  get,
  getByUserIdAndBusinessId,
  create,
  update,
  remove,
  getAvailableSpots,
  uploadFile,
  deleteFile
};
